import fetchWithToken from "views/auth/signIn/axiosInstance";

const API_BASE = `${process.env.REACT_APP_API_URL}/client/app-version`;
const PAGE_ID = 25;

/**
 * Get all app versions with optional pagination and date filters
 */
export const getAppVersions = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams({
      page_id: PAGE_ID,
      per_page: 10,
      ...params,
    });
    const response = await fetchWithToken(`${API_BASE}?${queryParams}`);
    return response;
  } catch (error) {
    throw error;
  }
};

/**
 * Get a single app version by ID
 */
export const getAppVersionById = async (id) => {
  try {
    const response = await fetchWithToken(`${API_BASE}/${id}?page_id=${PAGE_ID}`);
    return response;
  } catch (error) {
    throw error;
  }
};

/**
 * Create a new app version
 * @param {Object} data - App version data
 * @param {string} data.latest_version_android
 * @param {string} data.min_version_android
 * @param {string} data.store_url_android
 * @param {string} data.latest_version_ios
 * @param {string} data.min_version_ios
 * @param {string} data.store_url_ios
 * @param {string} data.title
 * @param {string} data.description
 * @param {boolean} data.force_update
 */
export const createAppVersion = async (data) => {
  try {
    const payload = {
      ...data,
      page_id: PAGE_ID,
    };
    const response = await fetchWithToken(
      `${API_BASE}?page_id=${PAGE_ID}`,
      "POST",
      payload
    );
    return response;
  } catch (error) {
    throw error;
  }
};

/**
 * Update an existing app version
 */
export const updateAppVersion = async (id, data) => {
  try {
    const payload = {
      id,
      ...data,
      page_id: PAGE_ID,
    };
    const response = await fetchWithToken(
      `${API_BASE}?page_id=${PAGE_ID}`,
      "PATCH",
      payload
    );
    return response;
  } catch (error) {
    throw error;
  }
};

/**
 * Delete an app version
 */
export const deleteAppVersion = async (id) => {
  try {
    const response = await fetchWithToken(
      `${API_BASE}/delete?page_id=${PAGE_ID}`,
      "DELETE",
      { id }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

/**
 * Extract version array from paginated response
 */
export const extractVersionsFromResponse = (response) => {
  if (!response) return [];

  // If response.data is an object with pagination info
  if (response.data && typeof response.data === 'object' && !Array.isArray(response.data)) {
    return response.data.data || [];
  }

  // If response.data is already an array
  if (Array.isArray(response.data)) {
    return response.data;
  }

  return [];
};

/**
 * Validate Android Store URL
 */
export const validateAndroidURL = (url) => {
  if (!url) return false;
  return url.includes('play.google.com');
};

/**
 * Validate iOS Store URL
 */
export const validateIOSURL = (url) => {
  if (!url) return false;
  return url.includes('apps.apple.com');
};
